import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TabPanel from './vertical-tab-panel';

const useStyles = makeStyles()((theme) => ({
  root: {
    [theme.breakpoints.up('sm')]: {
      display: 'flex'
    }
  },
  tabs: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.up('sm')]: {
      borderRight: `1px solid ${theme.palette.divider}`,
      borderBottom: 'none'
    },
  },
}));

type Props = {
  tabs: { label?: string; tab?: string }[];
  currentTab: string;
  children: React.ReactNode[];
  onChange: (event: React.SyntheticEvent, value: string) => void;
};

const VerticalTabs = ({ tabs, currentTab, children, onChange }: Props) => {
  const { classes } = useStyles();
  const theme = useTheme();
  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <div className={classes.root}>
      <Tabs
        orientation={isSmUp ? "vertical" : "horizontal"}
        variant="scrollable"
        value={currentTab}
        onChange={onChange}
        aria-label="Vertical tabs"
        className={classes.tabs}
      >
        {tabs.map(({ label, tab }) => (
          <Tab
            key={tab}
            label={label}
            value={tab}
            id={`vertical-tab-${tab}`}
            aria-controls={`vertical-tabpanel-${tab}`}
          />
        ))}
      </Tabs>
      {children}
    </div>
  );
};

VerticalTabs.TabPanel = TabPanel;

export default VerticalTabs;
